// validate duration up to 99h
const ValidateDuration = (val) => /^[0-9][0-9]:[0-5][0-9](:[0-5][0-9](:[0-9][0-9][0-9])?)?(\s+[ap]m)?$/i.test(val);
export default ValidateDuration;
